import {ContentHeader} from '@components';
import React, {useState, useEffect} from 'react';
import {FaEye, FaEyeSlash} from 'react-icons/fa';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useFormik} from 'formik';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-number-input';
import {logoutUser} from '@app/store/reducers/auth';
import {BASE_URL, hardCodedPermissions} from '../../config';
import {fetch} from '../../apiFunction';
import {getUserPermission} from '../../utils/helpers';
import handleStatus from '../../utils/ajax';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .max(30, 'User Name must not exceed 30 characters')
    .matches(/^[A-Za-z\s]+$/, 'User Name must contain only letters and spaces'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string().min(5, 'Password must be at least 5 characters'),
  mobile: Yup.string()
    .required('Phone number is required')
    .matches(
      /^(\+\d{1,3}[- ]?)?\d{10,14}$/,
      'Phone number must be between 10 and 14 digits'
    ),
  gender: Yup.string().oneOf(['male', 'female'], 'Invalid Gender'),
  dob: Yup.date(),
  // deactivated: Yup.boolean(),
  // permissions: Yup.array().min(1, 'At least one permission is required'),
  designation: Yup.string(),
  emergencyContact: Yup.string()
    .required('Emergency contact number is required')
    .matches(
      /^(\+\d{1,3}[- ]?)?\d{10,14}$/,
      'Emergency contact number must be between 10 and 14 digits'
    ),
  address: Yup.string()
    .max(300, 'Address must not exceed 300 characters')
    .nullable()
});

const initialValues = {
  name: '',
  email: '',
  password: '',
  mobile: '',
  gender: '',
  dob: '',
  deactivated: false,
  permissions: [],
  designation: '',
  emergencyContact: '',
  address: ''
};

const UpdateUser = () => {
  const [value, setValue] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const [emergencyContact, setEmergencyContact] = useState();
  const [styleForValidaiton] = useState({color: 'red'});
  const [formValues, setFormValues] = useState(initialValues);
  const navigate = useNavigate();
  const userId = useParams().id;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.currentUser);

  const getUserDetails = async (id) => {
    try {
      const url = `${BASE_URL}/user/${id}`;
      const token = localStorage.getItem('token');
      const resp = await fetch(url, 'GET', null, token);

      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      // handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp?.status === 200) {
        const response = await resp.data;
        setFormValues({
          ...response.data,
          permissions: response.data.permissions[0]
        });
      }
    } catch (error) {
      // console.log(error, 'error while getting user details');
    }
  };
  useEffect(() => {
    if (!userId) return;
    getUserDetails(userId);
  }, [userId, dispatch, navigate]);

  const onSubmit = async (values) => {
    try {
      // console.log(values, 'valeus*******************');
      const {name, mobile, dob, address, emergencyContact} = values;
      if (values.deactivated === 'false') {
        values.deactivated = false;
      } else {
        values.deactivated = true;
      }
      const url = `${BASE_URL}/user/update`;
      const type = 'post';
      const token = localStorage.getItem('token');
      const payload = {
        profile: '',
        name,
        mobile,
        dob,
        address,
        emergencyContact,
        userId,
        gender: values?.gender?.toLowerCase(),
        permission: Array.isArray(values.permissions)
          ? values.permissions[0]
          : values.permissions,
        designation: values?.designation,
        password: values?.password
      };

      const resp = await fetch(url, type, payload, token);
      if (resp && !resp?.data?.ok) {
        toast.error(resp?.data?.message || 'Error while updating user');
        return;
      }
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        toast.success('User Updated sucessfully');
        navigate('/all-users');
      }
    } catch (error) {
      console.error(error, 'error while updating an user.');
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formValues,
    validationSchema,
    onSubmit
  });

  const allPermissions = [
    {value: 'admin', label: 'Admin'},
    {value: 'business', label: 'Business'},
    {value: 'sales', label: 'Sales'},
    {value: 'hr', label: 'HR'},
    {value: 'seo', label: 'SEO'},
    {value: 'developer', label: 'Developer'}
  ];

  // Get current user's role
  const userRole = getUserPermission(user);

  // Filter permissions based on user role
  const filteredPermissions =
    userRole === 'hr'
      ? allPermissions.filter((perm) => perm.value !== 'admin')
      : allPermissions;

  return (
    <>
      <ContentHeader title="Update User" path="/all-users" />
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title">User Information</h3>
              </div>
              <div className="card-body">
                <div className="card card-primary">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="card-body d-flex flex-column gap-3">
                      <div className="row">
                        <label
                          htmlFor="inputName"
                          className="col-sm-2 col-form-label"
                        >
                          User Name
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control"
                            id="inputName"
                            placeholder="Name"
                            name="name"
                            maxLength={30}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                          />
                          {formik.touched.name && formik.errors.name ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.name}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="inputEmail"
                          className="col-sm-2 col-form-label"
                        >
                          Email
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="email"
                            className="form-control"
                            id="inputEmail"
                            placeholder="Email"
                            name="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            disabled
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.email}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="pexampleInputPassword1"
                          className="col-sm-2 col-form-label"
                        >
                          Password
                        </label>
                        <div className="col-sm-10">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            id="exampleInputPassword1"
                            placeholder="Password"
                            name="password"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                          />
                          <button
                            type="button"
                            style={{right: '5px', top: 0}}
                            className="btn position-absolute"
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                          {formik.touched.password && formik.errors.password ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.password}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div
                        className="row"
                        style={{
                          justifyContent: 'space-between'
                          // alignItems: 'center'
                        }}
                      >
                        <label htmlFor="inputName2" style={{textAlign: 'left'}}>
                          Mobile Number
                        </label>
                        <div className="col-sm-10">
                          <PhoneInput
                            defaultCountry="IN"
                            value={formik.values.mobile}
                            onChange={(phone) => {
                              formik.values.mobile = phone;
                              setValue(phone);
                            }}
                            limitMaxLength
                            style={{
                              width: '100%',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              padding: '4px'
                              // outline: 'none'
                            }}
                          />
                          {formik.touched.mobile && formik.errors.mobile && (
                            <div style={{color: 'red', marginTop: '5px'}}>
                              {formik.errors.mobile}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="inputSkills"
                          className="col-sm-2 col-form-label"
                        >
                          Gender
                        </label>
                        <div className="col-sm-10">
                          <select
                            className="form-control"
                            name="gender"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.gender || ''}
                          >
                            <option value="">Select</option>{' '}
                            {/* Ensure the empty option has value="" */}
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>

                          {formik.touched.gender && formik.errors.gender ? (
                            <div style={styleForValidaiton}>
                              {formik.errors.gender}{' '}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="dob"
                          className="col-sm-2 col-form-label"
                        >
                          Date of Birth
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="date"
                            name="dob"
                            className="form-control"
                            id="dob"
                            placeholder="date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.dob}
                          />
                          {formik.touched.dob && formik.errors.dob ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.dob}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="inputSkills"
                          className="col-sm-2 col-form-label"
                        >
                          Deactivated
                        </label>
                        <div className="col-sm-10">
                          <select
                            className="form-control"
                            name="deactivated"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.deactivated}
                          >
                            <option value="false">Activate</option>
                            <option value="true">Deactivate</option>
                          </select>
                          {formik.touched.deactivated &&
                          formik.errors.deactivated ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.deactivated}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="designation"
                          className="col-sm-2 col-form-label"
                        >
                          Designation
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            name="designation"
                            className="form-control"
                            id="inputDesignation"
                            placeholder="Designation"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.designation}
                          />
                          {formik.touched.designation &&
                          formik.errors.designation ? (
                            <div style={{color: 'red'}}>
                              {formik.errors.designation}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="inputPlace"
                          className="col-sm-2 col-form-label"
                        >
                          Permissions
                        </label>
                        <div className="col-sm-10">
                          <select
                            className="form-control"
                            name="permissions"
                            onChange={(event) => {
                              const selectedOptions = Array.from(
                                event.target.selectedOptions,
                                (option) => option.value
                              );
                              formik.setFieldValue(
                                'permissions',
                                selectedOptions
                              );
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.permissions}
                          >
                            {filteredPermissions.map((perm) => (
                              <option key={perm.value} value={perm.value}>
                                {perm.label}
                              </option>
                            ))}
                          </select>
                          {formik.touched.permissions &&
                          formik.errors.permissions ? (
                            <div style={styleForValidaiton}>
                              {formik.errors.permissions}{' '}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div
                        className="row"
                        style={{
                          justifyContent: 'space-between'
                          // alignItems: 'center'
                        }}
                      >
                        <label htmlFor="inputName2" style={{textAlign: 'left'}}>
                          Emergency Number
                        </label>
                        <div className="col-sm-10">
                          <PhoneInput
                            defaultCountry="IN"
                            value={formik.values.emergencyContact}
                            onChange={(emergencyContact) => {
                              formik.values.emergencyContact = emergencyContact;
                              setEmergencyContact(emergencyContact);
                            }}
                            limitMaxLength
                            style={{
                              width: '100%',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              padding: '4px'
                              // outline: 'none'
                            }}
                          />
                          {formik.touched.emergencyContact &&
                            formik.errors.emergencyContact && (
                              <div style={{color: 'red', marginTop: '5px'}}>
                                {formik.errors.emergencyContact}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row">
                        <label
                          htmlFor="address"
                          className="col-sm-2 col-form-label"
                        >
                          Address
                        </label>
                        <div className="col-sm-10">
                          <textarea
                            className="form-control"
                            id="inputAddress"
                            name="address"
                            placeholder="Address"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.address}
                          />
                        </div>
                      </div>
                      <div>
                        <button
                          type="submit"
                          className="btn btn-primary offset-md-2"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateUser;
